/** @format */
import { Market } from '@toucan/config/markets';

import { getConfig } from '@toucan/helpers/settings';

import { TrustpilotConfig } from '@toucan/client/shared/components/trustpilot';

/**
 * Within the Trustpilot dashboard, reviews can be tagged with these custom names, this allows us to show different featured
 * reviews at different areas of the platform
 */
/* cSpell: disable */
const trustPilotTags = {
    general: {
        UK: 'UKfeatureonsite',
        US: 'USfeatureonsite',
        DE: 'DEfeatureonsite',
        FR: 'FRfeatureonsite',
        EU: 'UKfeatureonsite',
        NL: 'NLfeatureonsite',
        AT: 'DEfeatureonsite',
        'NL-BE': 'NLfeatureonsite',
        'FR-BE': 'FRfeatureonsite',
        IT: 'ITfeatureonsite',
        IE: 'UKfeatureonsite',
        ES: 'ESfeatureonsite',
        PT: 'PTfeatureonsite',
    },
};
/* cSpell: enable */

/**
 * Config object containing template ids for different widgets. The keys map to the names
 * inside Trustpilot dashboard.
 */
export const TRUSTPILOT_TEMPLATE_IDS = {
    microCombo: '5419b6ffb0d04a076446a9af',
    microReviewCount: '5419b6a8b0d04a076446a9ad',
    slider: '54ad5defc6454f065c28af8b',
    mini: '53aa8807dec7e10d38f59f32',
    microStar: '5419b732fbfb950b10de65e5',
    carousel: '53aa8912dec7e10d38f59f36',
};

/**
 * Returns a partial of the trustpilot config, containing re-used parts
 */
export function getCommonTrustpilotConfig(market: Market): TrustpilotConfig {
    const { publicRuntimeConfig } = getConfig();
    return {
        businessUnitId: publicRuntimeConfig.trustPilot.businessUnitId,
        locale: market.slug,
        website: publicRuntimeConfig.trustPilot.url,
        tags: trustPilotTags.general[market.code],
    };
}

declare let window: any;

class Trustpilot {
    private queue: any[];
    private isAttached: boolean;

    public constructor() {
        this.queue = [];
        this.isAttached = false;
    }

    public attach() {
        if (this.isAttached) {
            return;
        }

        this.isAttached = true;

        const script = document.createElement('SCRIPT') as HTMLScriptElement;
        document.body.appendChild(script);
        script.addEventListener('load', this.onLoad);

        script.id = 'trustpilot';
        script.src =
            '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
        script.type = 'text/javascript';
        script.async = true;
    }

    public loadFromRef(ref: any) {
        if (window.Trustpilot) {
            window.Trustpilot.loadFromElement(ref.current, true);
        } else {
            this.queue.push(ref);
        }
    }

    public onLoad = (): void => {
        this.queue.forEach((ref) => {
            window.Trustpilot.loadFromElement(ref.current, true);
        });
        this.queue = [];
    };
}

export const trustpilot = new Trustpilot();
